export interface DirectoryUser {
  id: string;
  email: string;
  full_name: string | null;
  role: 'admin' | 'normal' | 'reviewer';
  is_active: boolean;
  is_internal: boolean;
  is_moral: boolean;
  last_login: string | null;
  created_at: string;
  updated_at: string;
  user_organization?: {
    organization: { id: string; name: string; hexcode: string | null };
    is_active: boolean;
    is_main: boolean;
  }[];
  user_extra_mails?: { id: string; email: string | null; created_at: string }[];
}
const normalize = (value: string) =>
  value
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('es');
export function filterDirectory(
  users: DirectoryUser[],
  filters: { search: string; role: string; status: string; org: string },
  sort: string,
) {
  const search = normalize(filters.search);
  return users
    .filter(
      (user) =>
        (!search ||
          normalize(`${user.full_name || ''} ${user.email}`).includes(
            search,
          )) &&
        (filters.role === 'all' || user.role === filters.role) &&
        (filters.status === 'all' ||
          (filters.status === 'active' && user.is_active) ||
          (filters.status === 'inactive' && !user.is_active) ||
          (filters.status === 'never_logged' && !user.last_login)) &&
        (filters.org === 'all' ||
          user.user_organization?.some(
            (item) => item.is_active && item.organization.id === filters.org,
          )),
    )
    .sort((a, b) => {
      if (sort === 'recent') {
        const difference =
          (Date.parse(b.last_login || '') || 0) -
          (Date.parse(a.last_login || '') || 0);
        if (difference) return difference;
      }
      return (
        (a.full_name || a.email).localeCompare(b.full_name || b.email, 'es', {
          sensitivity: 'base',
        }) || a.id.localeCompare(b.id)
      );
    });
}
export const DIRECTORY_PAGE_SIZE = 25;
export function directoryPage(value: string | null, total: number) {
  const parsed = Number(value);
  return Math.min(
    Math.max(1, Math.ceil(total / DIRECTORY_PAGE_SIZE)),
    Number.isSafeInteger(parsed) && parsed > 0 ? parsed : 1,
  );
}
